/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import { ButtonSubmit, Container, Content, Title } from '../../GlobalStyle'
import BoxShadow from '../components/BoxShadowDiv'
import { Format, Manual, MonthButton, Table, Total, TotalText, TotalTitle } from './style'

import { ProgressSpinner } from 'primereact/progressspinner'
import { useMemo } from 'react'
import { AiFillCaretRight, AiOutlinePlus } from 'react-icons/ai'
import { HiOutlineChevronLeft, HiOutlineChevronRight } from 'react-icons/hi'
import { useQuery } from 'react-query'
import api from '../../hooks/API'
import { Mask } from '../../hooks/Mask'
import { CurrencyInput } from '../../hooks/MaskInput'
import {
  useAddFixedExpenses,
  useDeleteFixedExpenses,
  useUpdateExpenses,
} from '../../hooks/mutations'
import { reverseFormatMoney } from '../../hooks/removeFormat'
import { Button } from '../components/Buttons/NormalButtons'
import TrashButton from '../components/Buttons/NormalButtons/TrashButton'
import Header from '../components/Header'
import { Input } from '../components/Input/style'
import { Toggle } from '../components/ToggleButton'

const Fixed = () => {
  const { isLoading, data: fixed } = useQuery(['fixed'], () => api.getFixedExpenses())
  const { isSuccess, data: salesData } = useQuery(['fixedSales'], () => api.getFixedSalesExpenses())
  const { data: profile } = useQuery(['profile'], () => api.getProfile())
  const { mutate: updateFixed } = useUpdateExpenses()
  const [removedItems, setRemovedItems] = useState([])
  const [totalByMonth, setTotalByMonth] = useState({ month1: 0, month2: 0, month3: 0 })

  const [data, setData] = useState([{ name: '', month1: 0, month2: 0, month3: 0 }])
  const [total, setTotal] = useState(0)

  const [currentMonthIndex, setCurrentMonthIndex] = useState()
  const [previousData, setPreviousData] = useState([])
  const [totalSales, setTotalSales] = useState(0)

  const [automatic, setAutomatic] = useState(true)
  const [lastThreeMonths, setLastThreeMonths] = useState([
    getMonthName((currentMonthIndex - 2 + 12) % 12),
    getMonthName((currentMonthIndex - 1 + 12) % 12),
    getMonthName(currentMonthIndex),
  ])
  const nextMonth = (currentMonthIndex - 1 + 12) % 12
  const nextNextMonth = (currentMonthIndex - 2 + 12) % 12

  const { mutate: addFixedExpense } = useAddFixedExpenses()

  const { mutate: removeFixedExpense } = useDeleteFixedExpenses()

  useEffect(() => {
    let sum = 0
    if (isSuccess) {
      sum += salesData?.data?.mes_1 + salesData?.data?.mes_2 + salesData?.data?.mes_3

      console.log(salesData)
      console.log(sum)
      setTotalSales(sum)
    }
  }, [isSuccess])

  useEffect(() => {
    const currentMonthIndex = fixed?.partida_mes
    console.log(fixed)
    if (currentMonthIndex) {
      setLastThreeMonths([
        getMonthName((currentMonthIndex - 2 + 12) % 12),
        getMonthName((currentMonthIndex - 1 + 12) % 12),
        getMonthName(currentMonthIndex),
      ])

      const transformedData = fixed.data.map((item) => ({
        id: item.id,
        name: item.nome,
        month1: item?.mes_1,
        month2: item?.mes_2,
        month3: item?.mes_3,
      }))
      setData(transformedData)
      setCurrentMonthIndex(currentMonthIndex)
    }
  }, [fixed])

  useEffect(() => {
    automatic ? setTotal(profile?.despesas_fixas) : null
  }, [profile])

  const handleInputChange = (event, index, value) => {
    const { name } = event.target
    if (name == 'name') value = event.target.value
    const list = [...data]
    list[index][name] = value
    setData(list)
    const sum = data.reduce((acc, item) => acc + item.month1 + item.month2 + item.month3, 0)
    automatic ? setTotal((sum / totalSales) * 100) : null
  }

  const handleAddRow = () => {
    setData([...data, { name: '', month1: 0, month2: 0, month3: 0 }])
  }

  const handleCloneRow = (index) => {
    const newState = data.map((obj, i) => {
      if (i == index) {
        return {
          ...obj,
          month2: obj.month1,
          month3: obj.month1,
        }
      }
      return obj
    })
    setData(newState)
  }
  const handleRemoveRow = (index) => {
    // Remove row from the database if it has an id property
    if (data[index].id) {
      setRemovedItems([...removedItems, data[index].id])
    }

    // Remove row from the table
    const list = [...data]
    list.splice(index, 1)
    setData(list)
  }

  useEffect(() => {
    const sum = data.reduce((acc, item) => acc + item.month1 + item.month2 + item.month3, 0)
    automatic ? setTotal((sum / totalSales) * 100) : null
    console.log(totalSales)
  }, [handleRemoveRow])

  const handleCalculateTotal = () => {
    let sum = 0
    data.forEach((item) => {
      sum += item.month1 + item.month2 + item.month3
    })
    setTotal(sum)
  }

  const handleNextMonth = () => {
    setPreviousData([...previousData, data])

    setCurrentMonthIndex((currentMonthIndex + 1) % 12)
    setLastThreeMonths([
      getMonthName((currentMonthIndex - 1 + 12) % 12),
      getMonthName(currentMonthIndex),
      getMonthName((currentMonthIndex + 1) % 12),
    ])
    updateTableForNewMonth()
  }

  const handlePreviousMonth = () => {
    if (previousData.length > 0) {
      setData(previousData[previousData.length - 1])
      setPreviousData(previousData.slice(0, -1))
      setCurrentMonthIndex((currentMonthIndex - 1 + 12) % 12)
      setLastThreeMonths([
        getMonthName((currentMonthIndex - 3 + 12) % 12),
        getMonthName((currentMonthIndex - 2 + 12) % 12),
        getMonthName((currentMonthIndex - 1 + 12) % 12),
      ])
    }
  }

  const handleSave = () => {
    data.forEach((item) => {
      addFixedExpense({
        id: item.id,
        nome: item.name,
        meses: [
          reverseFormatMoney(item.month1),
          reverseFormatMoney(item.month2),
          reverseFormatMoney(item.month3),
        ],
        inicio: currentMonthIndex,
      })
    })

    removedItems.forEach((id) => {
      removeFixedExpense(id)
    })

    updateFixed({ fixas: total })

    setRemovedItems([])
  }

  const updateTableForPreviousMonth = () => {
    if (previousData.length > 0) {
      setData(previousData[previousData.length - 1])
      setPreviousData(previousData.slice(0, -1))
      setCurrentMonthIndex((currentMonthIndex - 1 + 12) % 12)
      setLastThreeMonths([
        getMonthName((currentMonthIndex - 3 + 12) % 12),
        getMonthName((currentMonthIndex - 2 + 12) % 12),
        getMonthName((currentMonthIndex - 1 + 12) % 12),
      ])
    }
  }

  const updateTableForNewMonth = () => {
    setData(data.map((item) => ({ ...item, month1: item.month2, month2: item.month3, month3: '' })))
  }

  function getMonthName(monthIndex) {
    const monthNames = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ]
    return monthNames[monthIndex]
  }

  const sumFixed = useMemo(() => {
    let total = 0
    data.forEach((item) => {
      total += item.month1 + item.month2 + item.month3
    })
    return total
  }, [data])

  const avrg = (sales, index, total) => {
    const sale1 = sales[index].month1
    const sale2 = sales[index].month2
    const sale3 = sales[index].month3

    const avrgData = (index, (sale1 + sale2 + sale3) / total) * 100

    return avrgData
  }

  useEffect(() => {
    const calcularSoma = (array) => {
      let soma = array?.reduce(
        (acc, curr) => {
          acc.month1 += curr.month1
          acc.month2 += curr.month2
          acc.month3 += curr.month3
          return acc
        },
        { month1: 0, month2: 0, month3: 0 }
      )
      return soma
    }

    setTotalByMonth(calcularSoma(data))
  }, [data])

  if (isLoading)
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <ProgressSpinner size="6rem" />
      </div>
    )

  return (
    <Content>
      <Title>Despesas fixas</Title>
      <BoxShadow overflow={'initial'} minWidth={'550px'}>
        <Header title={'Fixas'} />

        <Container>
          <Total>
            <TotalTitle>{automatic ? 'Despesas por mês' : 'Despesa manual'}</TotalTitle>
            <Format>
              <p>Automático</p>
              <Toggle toggled={true} onClick={() => setAutomatic(!automatic)} />
            </Format>

            <TotalText>
              <span>%</span>
              {Mask.percent(total).slice(2)}
            </TotalText>
          </Total>

          {automatic ? (
            <>
              <Table>
                <thead>
                  <tr>
                    <th style={{ width: '24%' }}>Nome</th>
                    <th style={{ width: '22%' }}>{lastThreeMonths[0]}</th>
                    <th style={{ width: '22%' }}>{lastThreeMonths[1]}</th>
                    <th style={{ width: '22%' }}>{lastThreeMonths[2]}</th>
                    <th style={{ width: '10%', minWidth: '50px' }}>%</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <MonthButton onClick={handleNextMonth}>
                    <HiOutlineChevronRight />
                  </MonthButton>

                  <MonthButton plus onClick={handlePreviousMonth}>
                    <HiOutlineChevronLeft />
                  </MonthButton>

                  <tr>
                    <td>
                      <Input type="text" name="name" value={'Totais'} disabled />
                    </td>
                    <td>
                      <CurrencyInput
                        type="text"
                        name="total1"
                        value={totalByMonth.month1}
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput
                        type="text"
                        name="total2"
                        value={totalByMonth.month2}
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput
                        type="text"
                        name="total3"
                        value={totalByMonth.month3}
                        disabled
                      />
                    </td>
                    <td>
                      <CurrencyInput type="text" name="avrg" value={100} disabled />
                    </td>
                  </tr>

                  {data.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <Input
                          type="text"
                          name="name"
                          value={item.name}
                          onChange={(event) => handleInputChange(event, index)}
                        />
                      </td>
                      <td>
                        <CurrencyInput
                          type="text"
                          name="month1"
                          defaultValue={0}
                          value={item.month1}
                          onChangeValue={(event, originalValue) =>
                            handleInputChange(event, index, originalValue)
                          }
                        />
                      </td>
                      <td>
                        <CurrencyInput
                          type="text"
                          name="month2"
                          defaultValue={0}
                          value={item.month2}
                          onChangeValue={(event, originalValue) =>
                            handleInputChange(event, index, originalValue)
                          }
                        />
                      </td>
                      <td>
                        <CurrencyInput
                          type="text"
                          name="month3"
                          defaultValue={0}
                          value={item.month3}
                          onChangeValue={(event, originalValue) =>
                            handleInputChange(event, index, originalValue)
                          }
                        />
                      </td>

                      <td>
                        <CurrencyInput
                          currency={'percent'}
                          value={avrg(data, index, sumFixed)}
                          disabled
                        />
                      </td>
                      <td>
                        <Button color={'#3460a6'} onClick={() => handleCloneRow(index)}>
                          <AiFillCaretRight style={{ position: 'absolute' }} />
                        </Button>
                      </td>
                      <td>
                        <TrashButton onClick={() => handleRemoveRow(index)} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <ButtonSubmit
                rounded
                width={'auto'}
                height={'auto'}
                padding={'12px'}
                onClick={handleAddRow}
                margin={'15px 0px 0px 0px'}
              >
                <AiOutlinePlus />
              </ButtonSubmit>
              <button style={{ display: 'none' }} onClick={handleCalculateTotal}>
                Calculate
              </button>
            </>
          ) : (
            <Manual>
              <p>Informe a despesa fixa</p>
              <CurrencyInput
                currency={'percent'}
                value={total}
                onChangeValue={(_, originalValue) => setTotal(originalValue)}
                width={'30%'}
              />
            </Manual>
          )}

          <ButtonSubmit margin={'15px 0px 0px 0px'} onClick={handleSave}>
            Salvar
          </ButtonSubmit>
        </Container>
      </BoxShadow>
    </Content>
  )
}
export default Fixed
